import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

interface ExportDialogProps {
  open: boolean;
  onClose: () => void;
  onExport: () => void;
  loading: boolean;
  exportFormat: 'csv' | 'pdf' | 'excel';
  onFormatChange: (format: 'csv' | 'pdf' | 'excel') => void;
}

const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  onClose,
  onExport,
  loading,
  exportFormat,
  onFormatChange
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <DownloadIcon />
          <Typography variant="h6">Export Payrolls</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Export Format</InputLabel>
            <Select
              value={exportFormat}
              label="Export Format"
              onChange={(e) => onFormatChange(e.target.value as 'csv' | 'pdf' | 'excel')}
            >
              <MenuItem value="csv">CSV (Comma Separated Values)</MenuItem>
              <MenuItem value="excel">Excel Spreadsheet</MenuItem>
              <MenuItem value="pdf">PDF Report</MenuItem>
            </Select>
          </FormControl>
          
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            {exportFormat === 'csv' && 'Export data in CSV format for easy import into other systems.'}
            {exportFormat === 'excel' && 'Export as Excel file with formatting and formulas.'}
            {exportFormat === 'pdf' && 'Export as PDF document for printing and sharing.'}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onExport} 
          variant="contained"
          disabled={loading}
          startIcon={<DownloadIcon />}
        >
          Export as {exportFormat.toUpperCase()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDialog;
